

export const tabAction = () => {
  
  const tabActionWrapper = document.querySelector('.js-tab-action');
  if (!tabActionWrapper) return;
  const tabList = tabActionWrapper.querySelectorAll('[data-tab]');
  const tabContent = tabActionWrapper.querySelectorAll('.info-list-wrap');
  tabList.forEach(tab => {
    tab.addEventListener('click', () => {
      tabList.forEach(tab => {
        tab.classList.remove('is-active');
      });
      tab.classList.add('is-active');
      const tabCategory = tab.dataset.tab;
      tabContent.forEach(content => {
        if (content.dataset.cat === tabCategory) {
          content.classList.add('is-active');
        } else {
          content.classList.remove('is-active');
        }
      });
    });
  });
};  